import { createFileRoute } from '@tanstack/react-router';
import { BrandingAssetDetailPage } from '@/pages/member-portal/branding/BrandingAssetDetailPage';

function MemberPortalBrandingAssetDetailRoute() {
	return <BrandingAssetDetailPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/branding_/$id')({
	component: MemberPortalBrandingAssetDetailRoute,
});
